export const paddingLeft = (num:any, length = 2) => {
    num = "" + num;

    for (;num.length < length;) {
        num = "0" + num;
    }
    return num;
};

export const paddingRight = (num:any, length = 2) => {
    num = "" + num;

    for (;num.length < length;) {
        num += "0";
    }
    return num;
};

export const createString = (char:string, length = 2) => {
    let ret = "";
    for (;ret.length < length;) {
        ret += char;
    }
    return ret;
};

export const reverse = function(str:string) {
    let ret = "";
    for (let i = str.length - 1; i > -1; i--) {
        ret += str[i];
    }
    return ret;
};

export const hashCode = function(str:string) {
    let hash = 0, i:number, chr:number;
    if (str.length === 0) return hash;
    for (i = 0; i < str.length; i++) {
        chr   = str.charCodeAt(i);
        hash  = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash < 0 ? -hash : hash;
};


export const selectByHash = (col:string | any[], feed:string) => {
    return col[hashCode(feed) % col.length];
};

export const commonStart = (...strs:string[]) => {
    for (let i = 0; ; i++) {
        if (i === strs[0].length) {
            return strs[0];
        }
        for (const str of strs) {
            if (str[i] !== strs[0][i]) {
                return strs[0].substring(0, i);
            }
        }
    }
};

/**
 * Make the first letter of a string uppercase
 */
export const upperCase1 = (str:string) => str[0].toUpperCase() + str.substring(1);

export const upperCase2 = (str:string) => str[0].toUpperCase() + str.substring(1).toLowerCase();
export const upperCaseWord = (str:string) => str.split(" ").map((word) => word[0].toUpperCase() + word.substring(1).toLowerCase()).join(" ");

export const isBlankStr = function(str:string) {
    return str == null || (typeof str === "string" && str.trim() === "");
};

export const capitalize = (str:string) => str.split(" ").map(upperCase1).join(" ");

export const decimalToBase64 = (number: string): string => {
    const base64Digits = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';
    let shortBase64 = '';
    let bigIntNumber = BigInt(number);
    const bigInt64 = BigInt(64);

    while (bigIntNumber > 0) {
        const remainder = bigIntNumber % bigInt64;
        shortBase64 = base64Digits[Number(remainder)] + shortBase64;
        bigIntNumber = bigIntNumber / bigInt64;
    }
    return shortBase64;
};

/**
 * Converts camelCase or PascalCase strings to spaced words
 * Examples:
 *   "agentId" -> "Agent ID"
 *   "HTMLElement" -> "HTML Element"
 */
export const camelToSpaced = (str: string): string => {
    return str
        .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
        .replace(/([A-z])([0-9])/g, '$1 $2')
        .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2')
        .replace(/^./, char => char.toUpperCase())
        .trim();
};

/**
 * Converts spaced words to camelCase
 * Examples:
 *   "Agent Name" -> "agentName"
 *   "XML Http Request" -> "xmlHttpRequest"
 */
export const spacedToCamel = (str: string): string => {
    return str
        .split(/\s+/)
        .map((word, index) =>
            index === 0
                ? word.toLowerCase()
                : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join('');
};

